import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { updatePost } from "store/actions/post";
import JobAdService from "services/jobAd";
import PublishJobView from "./view";

class PublishJob extends Component {
  state = {
    error: false,
    isBoostingJobAd: false,
  };

  componentDidMount() {
    const { history, user } = this.props;

    if (!user.token || user.type !== "company") history.push("/");
  }

  setFormData = (type, value) => this.props.updatePost({ [type]: value });

  publish = () => {
    const { post, user, history } = this.props;
    const { isBoostingJobAd } = this.state;

    post["companyID"] = user.id;
    post["token"] = user.token;
    post["boosting"] = isBoostingJobAd;

    JobAdService.publishJob(post).then((res) => {
      if (res === "success") history.push("/?jobPublished=true");
      else if (res === "error") {
        this.setState({ error: true });
        window.scrollTo(0, 0);
      } else {
        history.push("/pricing");
        window.scrollTo(0, 0);
      }
    });
  };

  boostJobAd = (checked) => {
    if (checked) {
      const companyID = this.props.user.id;

      JobAdService.boostJob(companyID).then((res) => {
        if (res !== "success") {
          this.props.history.push("/payment?product=boost");
          window.scrollTo(0, 0);
        } else {
          this.setState({ isBoostingJobAd: true });
        }
      });
    } else this.setState({ isBoostingJobAd: false });
  };

  render() {
    const { error, isBoostingJobAd } = this.state;
    const { post } = this.props;
    return (
      <PublishJobView
        post={post}
        setFormData={this.setFormData}
        publish={this.publish}
        error={error}
        boostJobAd={this.boostJobAd}
        isBoostingJobAd={isBoostingJobAd}
      />
    );
  }
}

const mapStateToProps = ({ post, user }) => ({
  post,
  user,
});

const mapDispatchToProps = (dispatch) => ({
  updatePost: (data) => dispatch(updatePost(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PublishJob));
